import { BoxGeometry, EdgesGeometry, LineSegments } from 'three';
import { ShapeState3D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { CuboidMaterial } from '../../../materials/cuboid/cuboid-material';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { determineRendererLayers } from '../../../utils/shape-visibility-utils';
import { setRendererLayers } from '../../render-utils';
import {
  ConfigureMeshesConfiguration,
  RenderConfiguration,
} from '../abstract-mesh-helper';

export class CuboidWireframeMesh extends LineSegments<
  EdgesGeometry,
  CuboidMaterial
> {
  constructor(boxGeometry: BoxGeometry) {
    super(new EdgesGeometry(boxGeometry));
    this.userData = { meshType: 'CuboidWireframe' };
    this.frustumCulled = false;
  }

  dispose() {
    this.geometry.dispose();
  }

  updateRendererLayers(
    state: PointCloudContentState,
    renderConfig: RenderConfiguration,
    cuboidState: ShapeState3D,
  ) {
    const layers = determineRendererLayers(cuboidState, state, renderConfig);
    setRendererLayers(layers, this);
  }

  updateMaterial(
    { materialService }: ConfigureMeshesConfiguration,
    color: string,
  ) {
    this.material = materialService.get(CuboidMaterial, { color });
  }
}
